module.exports = __webpack_public_path__ + "img/family.22545aea.png";